import AttachmentItemComponent from './attachment-item';
export default AttachmentItemComponent.extend({
  tagName: 'ic-block',
  attributeBindings: ['data-type'],
  'data-type': 'attachment',
  classNames: ['pill', 'o__has-delete', 'upload-pill']
});